export default __webpack_public_path__ + "static/media/logo.3a673da2.webp";